import "../Css/home.css";
import Headings from "../components/Headings";
import Image from "../components/Image";
import ProjectsCards from "../components/ProjectsCards";
import Testomonials from "../components/Testomonials";
import { ProjectsCard, imges, navbar, testo } from "../json/data";

export default function Project() {
  return (
    <div className="Project">
      {imges.slice(3, 4).map((pic, i) => {
        return <Image key={i} pictures={pic.img} />;
      })}
      <div className="Right-project">
        {navbar.slice(2, 3).map((data, index) => {
          return (
            <Headings
              key={index}
              topDiscription={data.name}
              heading={data.heading}
            />
          );
        })}
        <div className="P-cards">
          <div className="testo-heading">
            <h2>OUR REECENT PROJECTS</h2>
          </div>
          {ProjectsCard.map((projectCard, i) => {
            return (
              <ProjectsCards
                key={i}
                img={projectCard.img}
                title={projectCard.title}
                discription={projectCard.discription}
                link={projectCard.link}
              />
            );
          })}
        </div>
        <div className="testominals-Team">
          <div className="testo-heading">
            <h3>WHAT CLIENT SAY?</h3>
          </div>
          {testo.map((testo, i) => {
            return (
              <Testomonials
                key={i}
                para={testo.para}
                img={testo.img}
                title={testo.title}
                disc={testo.discription}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
}
